import { adminHttpClient } from '../commons/adminHttpClient'
import { NamedItemInt } from '../../domain/common/namedItem'

export type SubscriptionPlansForPackageResponse = {
  code: string
  setupFee: number
  monthlyFee: number
  employeeFee: number
  frequency: NamedItemInt
  minimumSeats: number
  productId: number
  seatNumber: number
  originalSetupFee: number
  originalMonthlyFee: number
  originalEmployeeFee: number
  saveOnSetupFee: number
  saveOnMonthlyFee: number
  saveOnEmployeeFee: number
}

const getSubscriptionPlansForPackage = (
  subscriptionPackageId: string,
): Promise<SubscriptionPlansForPackageResponse[]> => {
  return adminHttpClient.get(`/Subscriptions/SubscriptionPlansForPackage/${subscriptionPackageId}`)
}
export default getSubscriptionPlansForPackage
